import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h2 style={{textAlign:'center'}}> sorrY!! Page Not Found</h2>
        </div>
    );
};

export default NoMatch;